import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
});

const BorderLinearProgress = withStyles({
    root: {
        height: 10,
        width: '100%',
        borderRadius: 20
        // backgroundColor: lighten('#ff6c5c', 0.5),
    },
    bar: {
        borderRadius: 20,
        // backgroundColor: '#ff6c5c',
    },
})(LinearProgress);

interface LinearDeterminateProps {
    start: number,
    end: number,
    setProgress: (pg: number) => void,
    cb : () => void,
}

const LinearDeterminate: React.FC<LinearDeterminateProps> = (props) => {
    const classes = useStyles();
    const [progress, setProgress] = React.useState(props.start);
    let initStart = props.start;
    // console.log('in progressbar initStart', initStart)

    // React.useEffect(() => {
    //     const timer = setInterval(() => {
    //         if (progress < props.end) {
    //             setProgress((prevProgress) => (Math.min(prevProgress + 0.1, props.end)));
                
    //             handleProgressChange();
    //             console.log(progress)
    //         }
    //     }, 100);
    //     return () => {
    //         clearInterval(timer);
    //     };
    // }, []);

    React.useEffect(() => {
        const tick = setTimeout(() => {
            // console.log('in progressbar ', initStart, progress, props.end)
            if (progress < props.end) {
                handleProgressChange(Math.min(props.end, progress+0.1));
                setProgress(Math.min(props.end, progress+0.1));
            }
            if (progress == props.end && initStart != progress) {
                // console.log('in progressbar end!!')
                // initStart = progress;
                props.cb();
            }
            
        }, 100);
    
        // eslint-disable-next-line consistent-return
        return () => clearTimeout(tick);
    }, [progress]);

    const handleProgressChange = (iProgress:number) => {
        props.setProgress(iProgress);
    }

    return (
        <div className={classes.root}>
            <Box alignItems="center" mr={1}>
                <BorderLinearProgress variant="determinate" value={(progress / props.end * 100)} />
            </Box>

        </div>
    );
}

interface LinearProgressBarProps {
    progress: number,
    end: number,
}

export const LinearProgressBar: React.FC<LinearProgressBarProps> = (props) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Box alignItems="center" mr={1}>
                <BorderLinearProgress variant="determinate" value={(props.progress / props.end * 100)} />
            </Box>

        </div>
    );
}

export default LinearDeterminate;